let json;
json = [
    {
      "Make": "Aprilia",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Aprilia",
      "Model": "Atlantic 300S Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Caponord",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "Dorsoduro 750",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Dorsoduro 900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "Dorsoduro 1200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Mana 850",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Mana 850 GT",
      "Year": "All",
      "Response": "Either Kit"
   },
   {
      "Make": "Aprilia",
      "Model": "Pegaso 50",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 125",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 600",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650ie",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650 Outback",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650 Road",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650 Strada",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso 650 Trail",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso Tuscany Tibet",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "Pegaso Tuscany Tibet Raid",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "RS 50",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RS 125 Replica ABS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RS 250",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RS4 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RSV4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RSV Mille",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RSV Mille R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RSV Mille SP",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "RX 125 ABS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Shiver",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Shiver 900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "SL1000 Falco",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36907497473"
    },
    {
      "Make": "Aprilia",
      "Model": "SR GT 200",
      "Year": "All",
      "Response": "Unknown"
    },
    {
      "Make": "Aprilia",
      "Model": "SX 125 ABS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "SXV 550",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Tuono 125 ABS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Aprilia",
      "Model": "Tuono V4",
      "Year": "All",
      "Response": "Top Kit"
    },
    {
      "Make": "Bajaj",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Bajaj",
      "Model": "CT 100",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Bajaj",
      "Model": "Pulsar 150 Classic",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Bajaj",
      "Model": "Pulsar 150 DTS-i",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Bajaj",
      "Model": "Pulsar NS160 / 160 NS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "32199538212963"
    },
    {
      "Make": "Bajaj",
      "Model": "Pulsar NS200 / 200 NS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "32199538212963"
    },
    {
      "Make": "Bajaj",
      "Model": "Pulsar RS200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "32199538212963"
    },
    {
      "Make": "Benelli",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Benelli",
      "Model": "502C Cruiser",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "BN 302 R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668962029667"
    },
    {
      "Make": "Benelli",
      "Model": "Caffenero 150",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "Leoncino 500 Trail",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "Tornado Tre 1300",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668962029667"
    },
    {
      "Make": "Benelli",
      "Model": "TNT 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "TNT 135",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "TNT 300",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "TNT 600",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "TRK 502X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Benelli",
      "Model": "Zafferano 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "BMW",
      "Model": "C evolution",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "C400 X",
      "Year": "All",
      "Response": "Either Kit"
    },
  {
      "Make": "BMW",
      "Model": "C400 GT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "C650 GT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "C650 Sport",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "Funduro 650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F650 Singles",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F650 Twins",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "F700GS",
      "Year": "‘06 - ‘13",
      "Response": "Top Kit",
      "variant": "36917829569"     
    },
    {
      "Make": "BMW",
      "Model": "F700GS",
      "Year": "‘14 - Present",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F750GS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F800GS",
      "Year": "‘06 - ‘13",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "F800GS",
      "Year": "‘14 - Present",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F850GS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "F800GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "F800ST",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "F800R",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "F900R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "F900XR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "G310 GS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "G310 R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "G310 R with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "G650GS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "HP4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1200GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1200LT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1200R Sport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1200RS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1200S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "K1300S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
  {
      "Make": "BMW",
      "Model": "K1600",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1100GS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1100R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1100RS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1100RT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1100S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1150GS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"      
    },
    {
      "Make": "BMW",
      "Model": "R1150R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1150RS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1150RT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200C",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200C with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit"
    },
    {
      "Make": "BMW",
      "Model": "R1200CL",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200GS",
      "Year": "‘98-’13",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200 Independent",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200 Montauk",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200R",
      "Year": "‘98-’13",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200RS",
      "Year": "‘98-’13",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200RT",
      "Year": "‘98-’13",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200GS",
      "Year": "‘14-Present",
      "Response": "Either Kit",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200R",
      "Year": "‘14-Present",
      "Response": "Either Kit",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200RS",
      "Year": "‘14-Present",
      "Response": "Either Kit",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200RT",
      "Year": "‘14-Present",
      "Response": "Either Kit",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R1200S",
      "Year": "‘All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "R1250GS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "R1250R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "R1250RS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "R1250RT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "R18",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "BMW",
      "Model": "R nineT",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant":"13111206150243",
      "showNotes": "show" 
    },
    {
      "Make": "BMW",
      "Model": "R nineT with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "R nineT /5",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "R nineT Pure",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "R nineT Racer",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569",
      "showNotes": "show"
    },
    {
      "Make": "BMW",
      "Model": "S1000R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"      
    },
    {
      "Make": "BMW",
      "Model": "S1000RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "BMW",
      "Model": "S1000XR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917829569"
    },
    {
      "Make": "Brixton",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Brixton",
      "Model": "BX 125 / Haycroft / R / X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "BX 150 / R / X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "Cafe Racer 150i",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30354972442723"
    },
    {
      "Make": "Brixton",
      "Model": "Classic 150i",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "Felsberg 125 X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "Glanville 250 X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "Saxby 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Brixton",
      "Model": "Scrambler 150i",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Buell",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Buell",
      "Model": "1125R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Buell",
      "Model": "1190 SX",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "1190 RX",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "1200 RX",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "Blast",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Buell",
      "Model": "Ulysses XB12X",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "Cyclone M2",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "Cyclone M2 Low",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Buell",
      "Model": "XB12Scg Lightning",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091"
    },
    {
      "Make": "Can-Am",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Can-Am",
      "Model": "Ryker",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Can-Am",
      "Model": "Ryker Rally Edition",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder F3",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder F3 Limited",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder F3-S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder F3-T",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder GS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder RS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder RS-S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder RT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder RT Limited",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder RT-S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder ST",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder ST Limited",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Can-Am",
      "Model": "Spyder ST-S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CFMoto",
      "Model": "250NK",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "250SR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CFMoto",
      "Model": "300NK",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "300SR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CFMoto",
      "Model": "300SS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CFMoto",
      "Model": "400NK",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "450SS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CFMoto",
      "Model": "650 Adventura",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "650GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CFMoto",
      "Model": "650NK",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "650MT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "700CL-X Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "700CL-X Heritage",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CFMoto",
      "Model": "700CL-X Sport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "33300030816355"
    },
    {
      "Make": "CSC",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "E-RT3 Scooter",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "ES5 Scooter",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "Monterey Scooter",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "RX1E",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "RX3 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CSC",
      "Model": "RX4 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "CSC",
      "Model": "RX6",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "SG250 San Gabriel Cafe Racer",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "CSC",
      "Model": "TT250 Enduro",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Derbi",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Derbi",
      "Model": "GPR 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "47287528161588"
    },
    {
      "Make": "Derbi",
      "Model": "GPR 250",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "47287528161588"
    },
    {
      "Make": "Ducati",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Ducati",
      "Model": "749",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "848",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "996",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Diavel",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Hypermotard 796",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Hypermotard 950",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Hypermotard 1100",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Hypermotard SP",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Hyperstrada",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 400",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 600",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 696",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 795",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
   {
      "Make": "Ducati",
      "Model": "Monster 800",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 821",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 900S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 937",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1000",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1000S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1100 Evo",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 1200S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster S2R 800",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster S2R Desmodue",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster S4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster S4R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster S4RS Testastretta",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 659 ABS",
      "Year": "All",
      "Response": "See Notes",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 796 ABS",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Monster 797",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Multistrada 620",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Multistrada 950",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Multistrada 1000",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Multistrada 1200 25° Anniversario",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale 899",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale 959",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale 1199",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale 1299",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale V2",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Panigale V4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Paso",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Scrambler",
      "Year": "‘15 - ’18",
      "Response": "See notes",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "Scrambler",
      "Year": "‘19-present",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Sport 1000",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Sport Classic",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Sport GT1000",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "Sport PaulSmart 1000 LE",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Ducati",
      "Model": "ST3",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "ST4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "ST4s",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "Streetfighter S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193"
    },
    {
      "Make": "Ducati",
      "Model": "SuperSport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Ducati",
      "Model": "SuperSport S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36917888193",
      "showNotes": "show"
    },
    {
      "Make": "Energica",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Energica",
      "Model": "Ego",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Energica",
      "Model": "Eva Ribelle",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091",
      "showNotes": "show"
    },
    {
      "Make": "Energica",
      "Model": "Eva EsseEsse9",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091",
      "showNotes": "show"
    },
    {
      "Make": "Energica",
      "Model": "Eva EsseEsse9+",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091",
      "showNotes": "show"
    },
    {
      "Make": "Energica",
      "Model": "Eva EsseEsse9+ RS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30869276885091",
      "showNotes": "show"
    },
    {
      "Make": "Fantic",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Fantic",
      "Model": "Caballero 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Fantic",
      "Model": "Caballero 250",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "Fantic",
      "Model": "Caballero 500",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "30355377520739"
    },
    {
      "Make": "FB Mondial",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "FB Mondial",
      "Model": "HPS 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30375386447971"
    },
    {
      "Make": "FB Mondial",
      "Model": "HPS 300",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30375386447971"
    },
    {
      "Make": "FB Mondial",
      "Model": "Pagani 1948 Sport Classic 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30375386447971"
    },
    {
      "Make": "FB Mondial",
      "Model": "Pagani 1948 Sport Classic 300",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30375386447971"
    },
    {
      "Make": "Hanway",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Hanway",
      "Model": "Blackcafe 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hanway",
      "Model": "Furious 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hanway",
      "Model": "Muscle 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hanway",
      "Model": "RAW 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hanway",
      "Model": "Scrambler 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Harley Davidson",
      "Model": "1200 Sportster Custom",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "883 Custom",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "883 Hugger",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "883 Low",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "883R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Breakout FXSB",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Breakout FXBRS 114",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "CVO (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Dyna Convertible",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Dyna Switchback FLD",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Dyna Wide Glide FXDWG",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Electra Glide (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Fat Bob",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Fat Boy",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Fat Boy S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Forty-Eight",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Freewheeler FLRT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "FXDR 114",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Glide",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Heritage Softail Classic",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Iron 883",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Low Rider",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Low Rider S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Night Rod Special",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Nightster",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Pan America 1250",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Road Glide (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Road King (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Roadster",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Screamin’ Eagle",
      "Year": "All",
      "Response": "Doesn’t Fit"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Seventy-Two",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Shrine",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Blackline FXS",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Cross Bones",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Deluxe",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Deuce",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Slim",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Slim S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Rocker FXCW",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Softail Rocker C FXCWC",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Sport Glide",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Sportster (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street 500",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street 750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street Rod",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street Bob",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street Glide",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street Glide Special",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Street Glide Trike",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Superlow",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Superlow 1200T",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Super Glide",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Super Glide Custom",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Super Glide Sport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Super Glide T-Sport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Tri Glide",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Tri Glide Ultra",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Tri Glide Classic",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "XL1200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "XL1200C H-D1",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "XR1200X",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "Ultra Limited",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "V Rod",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Harley Davidson",
      "Model": "V Rod Muscle",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918115777",
      "showNotes": "show"
    },
    {
      "Make": "Hero",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Hero",
      "Model": "Achiever",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "32199584120931"
    },
    {
      "Make": "Hero",
      "Model": "Glamour",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "HF Deluxe",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Maestro Edge",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Passion Pro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Passion XPro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Pleasure",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "32199584120931"
    },
    {
      "Make": "Hero",
      "Model": "Splendor Plus",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Super Splendor",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "XPulse 200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "XPulse 200T",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Xtreme 200r",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hero",
      "Model": "Xtreme 200s",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "32199584153699"
    },
    {
      "Make": "Hero",
      "Model": "Xtreme Sports",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Honda",
      "Model": "ADV150",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "ADV160",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "ADV350",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Africa Twin CRF1000L",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Africa Twin CRF1100L",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Africa Twin Adventure Sports",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Big Ruckus",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB125R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB250R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"     
    },
    {
      "Make": "Honda",
      "Model": "CB300R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB650R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB125F",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB300F",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "CB500F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
   {
      "Make": "Honda",
      "Model": "CB500X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB650F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB600F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CB599 Hornet",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CB750 Hornet",
      "Year": "'23 - Present",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB900C Custom",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB900F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CB919 Hornet",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CB1000R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB1000R+",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CB1100",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB1100 RS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CB1100 EX",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CB1100 EX with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CBF600",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF600S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF600SA",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF600N",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF1000A",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF1000F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBF1000GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR125R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR150R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR250R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR250RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR300R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR400F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR400R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR400RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR450SR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR500F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR500R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600F Hurricane",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600F2",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600F3",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600F4",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600F4i",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR600RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR650F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR650R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR750F Hurricane",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR750F Super Aero",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR900RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR929RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR954RR Fireblade",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR1000F Hurricane",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR1000RR Fireblade",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR1000RR-R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBR1100XX Super Blackbird",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "CBX",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL-Series",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL50",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL70",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL90",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL100",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL160",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL175",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL350",
      "Year": "All",
      "Response": "Either Kit"
    },
    { 
      "Make": "Honda",
      "Model": "CL360",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CL450",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF250L",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF250L Rally",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF300L",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF300L Rally",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF450L",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CRF450RL",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CT125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CTX 700 without OEM heated grips",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CTX 700 with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CTX 1300 Deluxe without OEM heated grips",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CTX 1300 Deluxe with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "CX500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CX500 Custom",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CX500 Deluxe",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CX650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "CX650C Custom",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Deauville NT650V",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Deauville NT700V",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "DN-01",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Forza Scooter 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Forza Scooter 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Forza Scooter 300",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Forza Scooter 750",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Fury VT1300CX",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1000",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1100",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1100A Aspencade",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1100DX De Luxe",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1100I Interstate",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200A Aspencade",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200DX De Luxe",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200I Interstate",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200L Limited Edition",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1200SE-i Special Edition - Injected",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1500 Aspencade",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1500 Interstate",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1500SE Special Edition",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1800",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1800 Tour",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing GL1800 F6B",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Gold Wing F6B Deluxe",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Grom MSX125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Hawk GT NT650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Hornet CB750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Integra Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Integra with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Interstate VT1300CT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Magna VF250C",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Magna VF500C V30",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Magna VF700C V42",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Magna VF750C V45",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Magna VF1100C V65",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Super Magna",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Monkey 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "NC 700 X",
      "Year": "All",
      "Response": "Either Kit", 
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "NC 750 X",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "NC 750 S",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 450",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 550",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 700",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Nighthawk 750",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "NM4",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "PC800 Pacific Coast",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "PCX125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "PCX150",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "PCX160 Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Phantom 750",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "RC51",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "RVT1000R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VTR1000SP1",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VTR1000SP2",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "Rebel 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Rebel 300",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Rebel 500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Rebel 1100",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Ruckus 50",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Saber VT1300CS",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "SCL500 / CL500 Scrambler",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "SH150i Scooter",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "SH300i Scooter",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 125",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 400",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT400",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 500",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT500C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 600",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT600C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT600CD Deluxe",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 700",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT700C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 750",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT750C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT750C2 Spirit",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT750CD Deluxe",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow Deluxe VT750DC Spirit",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow Deluxe VT750RS Retro Standard",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow NV750C Custom",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "NV750DC Shadow Slasher",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT750C ACE",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 800",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow VT800C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Shadow 1100",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Silver Wing Scooter FSC600A",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Stateline VT1300CR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "ST1100",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "ST1300",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Pan European",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Super Cub C125 ABS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Transalp XL400V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Transalp XL600V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Transalp XL650V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Transalp XL700V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Transalp XL750",
      "Year": "'24-Present",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie F6C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie GL1500C",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie GL1500CJ Interstate",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie GL1500CT Tourer",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie Rune",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Valkyrie 1800",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715"
    },
    {
      "Make": "Honda",
      "Model": "Varadero XL1000V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "Varadero XL125V",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "VF750F V45 Interceptor",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VFR750F Interceptor",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VFR800 Interceptor",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VFR800X Crossrunner",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "VFR800X Crossrunner with OEM heated grips",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "VFR1200F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VFR1200X Crosstourer",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VFR1200X Crosstourer with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "VTR1000F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VTR1000F SuperHawk",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VTR1000F Firestorm",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918098689"
    },
    {
      "Make": "Honda",
      "Model": "VTX 1100",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "VTX 1300",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "VTX 1800",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330799715",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "X-ADV",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Honda",
      "Model": "X-ADV with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "Honda",
      "Model": "XR 650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Horex",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Horex",
      "Model": "VR6 Cafe Racer",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30774914318435",
    },
    {
      "Make": "Horex",
      "Model": "VR6 Cafe Racer HL",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "30774914318435",
    },
    {
      "Make": "Horex",
      "Model": "VR6 Classic",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Horex",
      "Model": "VR6 Classic HL",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Horex",
      "Model": "VR6 RAW",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Husqvarna",
      "Model": "701 Enduro",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36801788993"
    },
    {
      "Make": "Husqvarna",
      "Model": "701 Supermoto",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36801788993"
    },
    {
      "Make": "Husqvarna",
      "Model": "FE 501",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "Norden 901",
      "Year": "All",
      "Response": "Not Compatible"
    },
    {
      "Make": "Husqvarna",
      "Model": "Svartpilen 401",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "Svartpilen 701",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "TE630",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "TR650 Strada",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "TR650 Terra",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "Vitpilen 401",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Husqvarna",
      "Model": "Vitpilen 701",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hyosung",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Hyosung",
      "Model": "GD (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668971303011"
    },
    {
      "Make": "Hyosung",
      "Model": "GT (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668971303011"
    },
    {
      "Make": "Hyosung",
      "Model": "GV (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Hyosung",
      "Model": "ST7",
      "Year": "All",
      "Response": "Either Kit"
  },
  {
    "Make": "Indian",
    "Model": "Other",
    "Year": "All",
    "Response": "Unconfirmed"
  },
  {
    "Make": "Indian",
    "Model": "Scout",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918550401"
  },
  {
    "Make": "Indian",
    "Model": "Scout Sixty",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918550401"
  },
  {
    "Make": "Indian",
    "Model": "Scout Bobber",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918550401"
  },
  {
    "Make": "Jawa",
    "Model": "Other",
    "Year": "All",
    "Response": "Unconfirmed"
  },
  {
    "Make": "Jawa",
    "Model": "RVM Daytona 350",
    "Year": "All",
    "Response": "Either Kit"
  },
  {
    "Make": "Janus",
    "Model": "Other",
    "Year": "All",
    "Response": "Unconfirmed"
  },
  {
    "Make": "Janus",
    "Model": "Gryffin 250",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "47281339040052",
    "showNotes": "show"
  },
  {
    "Make": "Janus",
    "Model": "Halcyon 250",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "47281339040052",
    "showNotes": "show"
  },
  {
    "Make": "Janus",
    "Model": "Halcyon 450",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "47281339040052",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "Other",
    "Year": "All",
    "Response": "Unconfirmed"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours",
    "Year": "‘86 - ‘06",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours GTR1000",
    "Year": "‘86 - ‘06",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours 1000GTR",
    "Year": "‘86 - ‘06",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours ZG1000",
    "Year": "‘86 - ‘06",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours 14",
    "Year": "‘07 - Present",
    "Response": "Top Kit",
    "variant": "36918635265",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours GTR1400",
    "Year": "‘07 - Present",
    "Response": "Top Kit",
    "variant": "36918635265",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours 1400GTR",
    "Year": "‘07 - Present",
    "Response": "Top Kit",
    "variant": "36918635265",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "Concours ZG1400",
    "Year": "‘07 - Present",
    "Response": "Top Kit",
    "variant": "36918635265",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "KLR 650",
    "Year": "‘87 - ‘07",
    "Response": "Bottom Kit",
    "variant": "13111330570339",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "KLR 650",
    "Year": "‘08 - ‘18",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "KLR 650",
    "Year": "’21 - Present",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "KLX 230",
    "Year": "All",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "KLX 250",
    "Year": "All",
    "Response": "Either Kit"
  },
  {
    "Make": "Kawasaki",
    "Model": "GPX750",
    "Year": "All",
    "Response": "Either Kit",
    "showNotes": "show"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 125",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 250",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 250SL",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 250R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 300",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja EX300",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 300R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 400",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 500",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 500R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja EX500",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja GPZ500S",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 600",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 600R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 636",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZX-6E",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZX-6R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZZR600",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 650",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 650R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ER-6f",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ER-6n",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja EX-6",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja Z1000S",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja Z1000SX",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja 1000",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZX-7R",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZX-7",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
  {
    "Make": "Kawasaki",
    "Model": "Ninja ZXR-750",
    "Year": "All",
    "Response": "Top Kit",
    "variant": "36918635265"
  },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZXR-750R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-7RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-9R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja GPZ900R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja Z900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-10R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-10RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-12R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX12RR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZZ-R1200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-14",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZX-14R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Ninja ZZR1400",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Nomad",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Super Sherpa",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330570339",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Versys 650",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330570339",
    },
    {
      "Make": "Kawasaki",
      "Model": "Versys 1000",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330570339",
    },
    {
      "Make": "Kawasaki",
      "Model": "Versys 1000GT with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Versys-X 250",
      "Year": "2019-present",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Versys-X 300",
      "Year": "2019-present",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Voyager",
      "Year": "2019-present",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Vulcan with black plastic throttle housing",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Vulcan with chrome throttle housing",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Vulcan 500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Vulcan Mean Streak 1600",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Vulcan S",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111330570339",
    },
    {
      "Make": "Kawasaki",
      "Model": "W800",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "W800 Cafe",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 400",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 650",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 800",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z 1000",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z900RS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Kawasaki",
      "Model": "Z900RS CAFE",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265",
      "showNotes": "show"
    },
    {
      "Make": "Kawasaki",
      "Model": "ZRX1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "Kawasaki",
      "Model": "ZRX1200R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918635265"
    },
    {
      "Make": "KTM",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "KTM",
      "Model": "390 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "625 LC4",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "625 SXC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "625 SMC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "640 LC4 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "640 LC4 Adventure R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "640 Duke II",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "640 Enduro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "640 Super Moto",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "690 Duke",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "690 Enduro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "690 SMC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "690 SMC R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "790 Adventure",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "KTM",
      "Model": "790 Duke",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "KTM",
      "Model": "890 Adventure",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "KTM",
      "Model": "890 Duke",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "KTM",
      "Model": "950 LC8 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "950 LC8 Adventure R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "950 LC8 Adventure S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "950 SM",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "950 Super Enduro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 LC8 Adventure",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 LC8 Adventure R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 LC8 Adventure S",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 SM",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 SMR Supermoto R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 SMT Supermoto T",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "990 Super Duke",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1050 Adventure",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1090 Adventure, R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1190 Adventure, R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Adventure R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Adventure S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Adventure T",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Duke",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Duke R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "1290 Super Duke GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "Duke 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "Duke 200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "Duke 250",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "Duke 390",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "Duke 620",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "EXC (All cc)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "KTM",
      "Model": "RC 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"      
    },
    {
      "Make": "KTM",
      "Model": "RC 200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "RC 250",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "RC 390",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "KTM",
      "Model": "RC8",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "Kymco",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Kymco",
      "Model": "Active",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "AK550",
      "Year": "All",
      "Response": "Not Compatible"
    },
    {
      "Make": "Kymco",
      "Model": "Agility",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Bet & Win",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Candy",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "CK 125",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Compagno",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Cruiser 125",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "CV3",
      "Year": "All",
      "Response": "Not Compatible"
    },
    {
      "Make": "Kymco",
      "Model": "Dink",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "DJS",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Downtown",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Frost",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "G-Dink",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Grandvista",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Heroism",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Hipster 125",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Jetix",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Jockey",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "K-Pipe",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "K-XCT",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Like",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Movie",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Movie XL",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "MyRoad 700i",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "New Sento",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "People",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Pulsar",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Quannon",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Racing King",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Sento",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Sport 50",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Sting",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Stryker",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Super 8",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Super 9",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Venox 250",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Visar",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Vitality 50",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "X-Town 300i",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Xciting",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Yager",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Yup",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "Zing",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Kymco",
      "Model": "ZX 50",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Lexmoto",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Lexmoto",
      "Model": "Hawk 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "46864655515956"
    },
    {
      "Make": "Lexmoto",
      "Model": "LS-N 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "46864655515956"
    },
    {
      "Make": "Lexmoto",
      "Model": "LXR 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "46864655515956"
    },
    {
      "Make": "Lexmoto",
      "Model": "Viper 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "46864655515956"
    },
    {
      "Make": "Mash",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Mash",
      "Model": "DirtStar Scrambler 400cc",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mash",
      "Model": "DirtStar Scrambler 500cc",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mash",
      "Model": "Family Side 400cc",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "All Models with OEM heated grips",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "1100 Sport Injected",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918700673"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 750 Touring",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 850",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 1200 Sport",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva 1200 Sport 4V",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva V750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva V850",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Breva V1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "California",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Griso 1200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Norge 1200",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "Stelvio 1200",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329914979"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "V7 II, III (All Models)",
      "Year": "All",
      "Response": "Either Kit",
    },
    {
      "Make": "Moto Guzzi",
      "Model": "V7 Racer",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36918835073"
    },
    {
      "Make": "Moto Guzzi",
      "Model": "V85TT",
      "Year": "All",
      "Response": "Either Kit",
    },
    {
      "Make": "Moto Guzzi",
      "Model": "V9 (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Moto Morini",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Moto Morini",
      "Model": "Seiemmezzo 6.5 SCR/STR",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "46864671211828"
    },
    {
      "Make": "Moto Morini",
      "Model": "X-Cape 650",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "46864671244596"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed",
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Akita",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Fat Sabbath",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "FSR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "GT-SS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "GT-SR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Hilts",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Mastiff",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Mongrel",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Mushman",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Razorback",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "RS-13",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Mutt Motorcycles",
      "Model": "Sabbath",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "MV Agusta",
      "Model": "Other",
      "Year": "All",
     "Response": "Unconfirmed"
    },
    {
      "Make": "MV Agusta",
      "Model": "Brutale 800 (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668979265635"
    },
    {
      "Make": "MV Agusta",
      "Model": "Dragster 800 (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668979265635"
    },
    {
      "Make": "MV Agusta",
      "Model": "F3 (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668979265635"
    },
    {
      "Make": "MV Agusta",
      "Model": "F4 (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668979265635"
    },
    {
      "Make": "MV Agusta",
      "Model": "RVS (All Models)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668979265635"
    },
    {
      "Make": "MV Agusta",
      "Model": "Turismo Veloce 800 (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Norton",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Norton",
      "Model": "Commando 961 Cafe Racer MKII",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8668989554787"
    },
    {
      "Make": "Norton",
      "Model": "Commando 961 Sport MKII",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Norton",
      "Model": "Dominator",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Norton",
      "Model": "V4 RR",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "8668989554787"
    },
    {
      "Make": "Piaggio",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
   },
   {
      "Make": "Piaggio",
      "Model": "BV400 HP Scooter",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "30870203891811"
    },
    {
      "Make": "Piaggio",
      "Model": "Medley S 125",
      "Year": "All",
      "Response": "Doesn’t Fit"
   },
    {
      "Make": "Quadro",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Quadro",
      "Model": "eQooder",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Quadro",
      "Model": "Qooder",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Quadro",
      "Model": "xQooder",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Quadro",
      "Model": "QV3",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Bullet (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Cafe Racer (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Classic (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Continental GT 650",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "8669001023587"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Himalayan",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Hunter 350",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Interceptor 650 (INT650)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Meteor 350",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Scram 411",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Royal Enfield",
      "Model": "Super Meteor 650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "SSR",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "SSR",
      "Model": "SF250X",
      "Year": "All",
      "Response": "Either Kit",
    },
    {
      "Make": "Suzuki",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Suzuki",
      "Model": "Address 110",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "B-King GSX1300BK",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Bandit",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Boulevard (All Models)",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329849443",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Burgman",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329849443"
    },
    {
      "Make": "Suzuki",
      "Model": "Burgman 200",
      "Year": "‘19",
      "Response": "Top Kit",
      "variant": "36919163585",
    },
    {
      "Make": "Suzuki",
      "Model": "Burgman 400",
      "Year": "‘19",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Burgman 650 Executive",
      "Year": "‘19",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "DR (All cc)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585",
      "showNotes": "show"    
    },
    {
      "Make": "Suzuki",
      "Model": "DR-Z (All cc)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585",
      "showNotes": "show"    
    },
    {
      "Make": "Suzuki",
      "Model": "GSR600",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "36919163585",
      "showNotes": "show" 
    },
    {
      "Make": "Suzuki",
      "Model": "GSR750",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "36919163585",
      "showNotes": "show" 
    },
    {
      "Make": "Suzuki",
      "Model": "GSX 250R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "GSX-F (All cc)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "GSX-R (All cc)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "GSX-R 750",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "GSX-S (All cc)",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
   },
    {
      "Make": "Suzuki",
      "Model": "GSX-S1000",
      "Year": "‘19",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Hayabusa",
      "Year": "All",
      "Response": "Top Kit",
       "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder C1800R",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder M1800R",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VL125",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VL250",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VL800 Volusia",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VL1500",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VS400",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VS600",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VS700",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VS800",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Intruder VS1400",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GS550M",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GS650G",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX250S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX400S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX750S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX1000SZ",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX1100SR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX1100SY",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Katana GSX1100SZ",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "KATANA 1000",
      "Year": "’20 - Current",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "Marauder",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Suzuki",
      "Model": "SV1000",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "SV650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Suzuki",
      "Model": "SFV650",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Suzuki",
      "Model": "SV650X",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "TU250X",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919163585"
    },
    {
      "Make": "Suzuki",
      "Model": "V-Strom",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329849443"
    },
    {
      "Make": "SWM",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "SWM",
      "Model": "SuperDual T",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "SWM",
      "Model": "SuperDual X",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "SYM",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "SYM",
      "Model": "All Models without OEM heated grips",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "SYM",
      "Model": "All Models with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit"
    },
    {
      "Make": "Triumph",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Triumph",
      "Model": "America (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Bonneville (All Models)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Daytona",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket III",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket III Classic",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket III Roadster",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket III Tourer",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket III Touring",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket 3 R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket 3 GT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket 3 TFC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket 3 Limited Edition",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Rocket 3 Special Edition",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Scrambler",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Triumph",
      "Model": "Speed Four",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Speed Triple",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561",
      "showNotes": "show"
    },
    {
      "Make": "Triumph",
      "Model": "Speed Twin",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Speedmaster",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Sprint GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Sprint ST",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Street Cup",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Street Triple",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Triumph",
      "Model": "Street Twin",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Thruxton",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Thunderbird 900",
      "Year": "‘95-’04",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Triumph",
      "Model": "Thunderbird 900 Sport",
      "Year": "‘95-’04",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Triumph",
      "Model": "Thunderbird",
      "Year": "‘09-Present",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XCx",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XCA",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XRx",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XRx LOW",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 800 XRT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 850 Sport",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 900",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 955i",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 1050",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 1200 XC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger 1200 XR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger Explorer XC",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger Explorer XR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Tiger Sport 660",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919178561"
    },
    {
      "Make": "Triumph",
      "Model": "Trident",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Triumph",
      "Model": "Trophy",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Ural",
      "Model": "Air",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Ambassador",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Baikal",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "cT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Dark Force",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "FRWL From Russia With Love",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Gaucho Rambler",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Gear Up",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "M70",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "M70 Anniversary",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Mir",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Patrol",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Red October",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Retro",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Sahara",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Solo sT",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "T",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Taiga",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Tourist",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Ural",
      "Model": "Yamal",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Vespa",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Vespa",
      "Model": "Vespa 946 RED",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Vespa",
      "Model": "GTS 300 Sei Giorni",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Victory",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Boardwalk",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Core",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Cross Country",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Crossroads",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Gunner",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Hammer",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Hammer S",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Hard-Ball",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Highball",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Jackpot",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Judge",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Kingpin",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Kingpin Deluxe",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Kingpin Tour",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Octane",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Magnum",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "V92C",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "V92SC Sport Cruiser",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "V92TC Touring Cruiser",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Vegas",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Vegas Jackpot",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Vegas 8-Ball",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Vision Street",
      "Year": "All",
      "Response": "Either Kit",
       "showNotes": "show"
    },
    {
      "Make": "Victory",
      "Model": "Vision Street Tour",
      "Year": "All",
      "Response": "Either Kit",
       "showNotes": "show"
    },
    {
      "Make": "Voge",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Voge",
      "Model": "DSX 500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Yamaha",
      "Model": "Bolt 950 (XV950 / Star Bolt)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Bolt 950R (XV950R)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "D’elight 125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FJ-09",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "FJR 1300",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ1",
      "Year": "‘01-’05",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZS1000 Fazer",
      "Year": "‘01-’05",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ1",
      "Year": "‘06-’15",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ1-S Fazer",
      "Year": "‘06-’15",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ1-N",
      "Year": "‘06-’15",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ6",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ6R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ8",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ-07",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ-09",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "FZ-10",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "Majesty YP400",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-01",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-03",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-07",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-09",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-10",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "MT-125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "NMAX 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "NMAX 155",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Raider",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star Limited Edition",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star Midnight Star",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star MM",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star Silverado",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star Warrior",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Road Star Wild Star",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Roadliner",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "Royal Star",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "SCR 950 Scrambler",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "SMAX Scooter",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "SR 400",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "Stratoliner",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "Super Ténéré XT1200Z",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Stryker",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "TDM900",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
    },
    {
      "Make": "Yamaha",
      "Model": "Ténéré 700 World Raid",
      "Year": "Prototype",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Ténéré 700, T700, T7",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "TMAX",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Tracer 700",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
    },
    {
      "Make": "Yamaha",
      "Model": "Tracer 700 GT",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
    },
    {
      "Make": "Yamaha",
      "Model": "Tracer 900",
      "Year": "‘15 - ‘18",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "Tracer 900",
      "Year": "‘19",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Tricity 125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "Tricity 300",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "TW200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "V Star 650, DragStar 650, XVS650",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "V Star 1100, DragStar 1100, XVS1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "V Star 1300",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "XVS1300A Midnight Star",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "XVS13AW(C)",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV125",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV250",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV400",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV500",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV535",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV700",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV750",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV920",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV1000",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV1100",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "Virago XV1100 with OEM heated grips",
      "Year": "All",
      "Response": "Doesn’t Fit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "VMAX",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "WR250R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XJ600S Diversion",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "XJ650 Maxim",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XJ900S Diversion",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "XJR1200",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XJR1300",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XJR1300C",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XJR1300C Racer",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "XMAX Scooter (All cc)",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XSR 500",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XSR 700",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XSR 900",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XT 225",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "XT 250",
      "Year": "All",
      "Response": "Bottom Kit",
      "variant": "13111329456227"
    },
    {
      "Make": "Yamaha",
      "Model": "XT1200Z Super Ténéré",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "XT600 Ténéré",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XT660R",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XT660Z Ténéré",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XTZ 750 SuperTénéré",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "XV950R",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamaha",
      "Model": "YX600T Radian",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF600R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF600R Thundercat",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF1000R",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF1000R Thunderace",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF-R125",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF-R1",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF-R3",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF-R6",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamaha",
      "Model": "YZF-R7",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
   {
      "Make": "Yamaha",
      "Model": "YZF-R15",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
   {
      "Make": "Yamaha",
      "Model": "YZF-R25",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamasaki",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Yamasaki",
      "Model": "800 Watt Electric Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "150cc Gasoline Scooter",
      "Year": "All",
      "Response": "Either Kit",
      "showNotes": "show"
    },
    {
      "Make": "Yamasaki",
      "Model": "1500 Watt Euro5 Electric Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Bushback",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Cruiser",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Dream",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "E-Taxi",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Euro 5 50cc Gasoline Scooter",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Fency",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Gallop",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Hawk VIII",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "Mercury-2",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamasaki",
      "Model": "Mio",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Yamasaki",
      "Model": "New Design Scooter",
      "Year": "All",
      "Response": "Either Kit",
     "showNotes": "show"
    },
    {
      "Make": "Yamasaki",
      "Model": "Racing Motorcycle (All CC)",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919264001"
    },
    {
      "Make": "Yamasaki",
      "Model": "Robot",
      "Year": "All",
      "Response": "Either Kit",
     "showNotes": "show"
    },
    {
      "Make": "Yamasaki",
      "Model": "V150",
      "Year": "All",
      "Response": "Either Kit",
     "showNotes": "show"
    },
    {
      "Make": "Yingang",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Yingang",
      "Model": "BM YG150-8",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Zero",
      "Model": "Other",
      "Year": "All",
      "Response": "Unconfirmed"
    },
    {
      "Make": "Zero",
      "Model": "Zero S",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919343297"
    },
    {
      "Make": "Zero",
      "Model": "Zero SR",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919343297"
    },
    {
      "Make": "Zero",
      "Model": "Zero SR/F",
      "Year": "All",
      "Response": "Top Kit",
      "variant": "36919343297"
    },
    {
      "Make": "Zero",
      "Model": "Zero DS",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Zero",
      "Model": "Zero DSR",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Zero",
      "Model": "Zero FX",
      "Year": "All",
      "Response": "Either Kit"
    },
    {
      "Make": "Zero",
      "Model": "Zero FXS",
      "Year": "All",
      "Response": "Either Kit"
    },
]


